import { render, staticRenderFns } from "./ViewResellerProductComponent.vue?vue&type=template&id=7291fc60"
import script from "./ViewResellerProductComponent.vue?vue&type=script&lang=js"
export * from "./ViewResellerProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports